import { Auracast } from '@shure/cloud/shared/models/devices';

import {
	AuracastAudioChannelFeatureFragment,
	AuracastEncryptionAudioChannelFeatureFragment,
	AuracastFeatureFragment,
	BluetoothPowerFeatureFragment
} from '../graphql/generated/cloud-sys-api';

import { mapBluetoothPowerFromSysApi } from './map-bluetooth-power';

export type AllAuracastAudioChannelFeatureFragments = AuracastAudioChannelFeatureFragment &
	AuracastEncryptionAudioChannelFeatureFragment;

export type AllAuracastDeviceFeatureFragments = AuracastFeatureFragment & BluetoothPowerFeatureFragment;

export function mapAuracastFromSysApi(
	auracastDevice: AllAuracastDeviceFeatureFragments | null,
	auracastAudioChannel?: AllAuracastAudioChannelFeatureFragments | null
): Auracast {
	return {
		available: auracastDevice?.auracast?.available ?? false,
		enabled: auracastAudioChannel?.auracast?.enabled ?? false,
		broadcastName: auracastAudioChannel?.auracast?.name,
		encryptionEnabled: auracastAudioChannel?.auracastEncryption?.enabled ?? false,
		broadcastCode: auracastAudioChannel?.auracastEncryption?.passphrase ?? undefined,
		bluetoothPowerLevel: mapBluetoothPowerFromSysApi(auracastDevice?.bluetoothPower?.level)
	};
}
